import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FC } from 'react';

import { Property } from 'shared-types/Property';

import { SignInV2 } from '@features/SignIn/pages/SignIn/v2';

import RegisterV1 from './containers/Register';

type RegisterVersionProps = {
  language: string;
  property: Property;
};

export const RegisterVersion: FC<RegisterVersionProps> = ({ language, property }) => {
  const isV2 = useFeatureIsOn('feature.ecom2');
  if (isV2) return <SignInV2 language={language} property={property} />;
  return (
    <RegisterV1
      language={language}
      propertyId={property.id}
      spaIntegrated={property.isSpaIntegrated}
    />
  );
};
